import React, {Component} from 'react';
import {Bar, BarChart, CartesianGrid, Legend, Tooltip, XAxis, YAxis, ReferenceArea} from 'recharts';
import ToolTipStitches from "./ToolTipStitches";
import LoadingSplash from "../../globalComponents/LoadingSplash";

// const {BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend} = Recharts;

class BiaxialBarChart extends Component {

    static defaultProps = {
        labelX: null,
        label1: 'Stitches',
        label2: 'Threadbreaks',
        color1: '#05548E',      //  New System: #05548E selected: #033255   //  Old System: #4BB2C5 selected: #78CCDD
        color2: '#ff5c00',      //  New System: #ff5c00 selected: #ffbb05   //  Old System: #EAA228 selected: #F8C05B
        drillDown: false,
    };

    // Ursprünglich in der package.json: "recharts": "^1.0.0-beta.6"
    constructor(props) {

        super(props);

        this.state = {
            selectedArea: null,
        };

        this.translate = this.props.translate;

        this.checkNewProps = this.checkNewProps.bind(this);
        this.handleClick = this.handleClick.bind(this);

    }

    componentWillReceiveProps(nextProps) {

        const sameProps = this.checkNewProps(nextProps.data, this.props.data);

        if (!sameProps) {
            this.setState({
                selectedArea: null,
            });
        }

    }

    checkNewProps(newProps, oldProps) {

        let sameProps = true;

        if (newProps.length === oldProps.length) {
            newProps.forEach(
                (newProp, index) => {
                    let oldProp = oldProps[index];

                    if (newProp.st !== oldProp.st || newProp.tb !== oldProp.tb) sameProps = false;
                }
            );
        } else {
            sameProps = false;
        }

        return sameProps

    }

    handleClick(data) {

        if (!data || data.activeIndex === undefined || data.activeIndex === null || this.props.chartKey === 'minutes') return;

        const activeIndex = data.activeIndex;

        if (this.props.drillDown) {
            this.setState({
                selectedArea: data,
            });
        }

        if (this.props.handleClick) {
            this.props.handleClick(activeIndex, this.props.chartKey);
        }

    }

    getTbAxisTick() {

        const maxValues = this.getMaxValues();

        let tbTick = 5;

        if (maxValues.st > 0 && maxValues.tb > 0) {
            if (maxValues.tb < 5) {
                tbTick = 5;
            } else {
                tbTick = Math.ceil(maxValues.tb / 10) * 15;
            }

        }

        return tbTick;
    }

    getMaxValues() {

        const chartData = this.props.data;

        let maxValues = {st: 0, tb: 0};

        for (let ix in chartData) {
            let data = chartData[ix];

            if (data.st > maxValues.st) maxValues.st = data.st;
            if (data.tb > maxValues.tb) maxValues.tb = data.tb;
        }

        return maxValues;

    }

    getNextXValue() {

        if (!this.state.selectedArea) return;

        const activeLabel = this.state.selectedArea.activeLabel;
        const data = this.props.data;

        let nextXValue = null;

        data.forEach(
            (labelData, index) => {
                if(labelData.name === activeLabel) {
                    if (data[index + 1]) nextXValue = data[index + 1].name;
                }
            }
        );

        return nextXValue;

    }

    getReferenceArea() {

        if (!this.state.selectedArea) return null;

        const nextXValue = this.getNextXValue();
        const attributes = {
            yAxisId: "left",
            x1: this.state.selectedArea.activeLabel,
            fill: '#ccc',
            fillOpacity: 1
        };

        //  If not last element of x-axis is selected, add x2 to object.
        if (nextXValue) attributes.x2 = nextXValue;

        return <ReferenceArea {...attributes} />;

    }

    render() {

        if (!this.props.data) return <LoadingSplash color={'#0e3043'}/>;

        const width = this.props.width ? this.props.width : 1200;
        const height = this.props.height ? this.props.height : 400;
        const xBandwidth = width / this.props.data.length;

        const labelX = this.props.labelX;
        const label1 = this.props.label1;
        const label2 = this.props.label2;
        const color1 = this.props.color1;
        const color2 = this.props.color2;

        const tbAxisTick = this.getTbAxisTick();
        const tbAxisTicks = [0, tbAxisTick, tbAxisTick * 2, tbAxisTick * 3, tbAxisTick * 4];

        const referenceArea = this.getReferenceArea();

        return (
            <BarChart data={this.props.data}
                      height={height}
                      width={width}
                      onClick={this.handleClick}>
                <XAxis dataKey="name" label={labelX} style={{fontSize: '0.8em'}}/>
                <YAxis yAxisId="left" orientation="left" stroke={color1} style={{color: color1, fontSize: '0.8em'}}/>
                <YAxis yAxisId="right" orientation="right" stroke={color2} ticks={tbAxisTicks} style={{color: color2, fontSize: '0.8em'}}/>

                <CartesianGrid strokeDasharray="3 3"/>

                <Tooltip content={<ToolTipStitches translate={this.translate}/>}/>

                <Legend
                    verticalAlign="top"
                    payload={[{value: label1, color: color1}, {value: label2, color: color2}]}
                />

                {referenceArea}

                <Bar yAxisId="left" dataKey="st" name={label1} fill={color1}/>
                <Bar yAxisId="right" dataKey="tb" name={label2} fill={color2}/>
            </BarChart>
        );

    }

}

export default BiaxialBarChart;